import 'regenerator-runtime/runtime';
import React, { Component } from 'react';
import { WixStyleReactProvider } from 'wix-style-react';
import { ServicesProvider } from '@wix/experts-common';
import Header from '../Header/Header';
import s from './app.scss';
import ArenaRouter from '../Router';
import ScrollToTop from '../ScrollToTop';

class App extends Component {
  isInModal = this.context.services.isInModal;

  render() {
    return (
      <div className={`${s.root} ${this.isInModal && s.inModal}`}>
        <WixStyleReactProvider as="span">
          {!this.isInModal && (
            <div className={s.headerWrapper}>
              <Header />
            </div>
          )}
          <div className={s.pagesWrapper}>
            <ScrollToTop>
              <ArenaRouter />
            </ScrollToTop>
          </div>
        </WixStyleReactProvider>
      </div>
    );
  }
}

App.contextTypes = ServicesProvider.childContextTypes;
export default App;
